// Button.js
import React from "react";

const Button = ({ text, children, classes, ...props }) => {
  return (
    <button className={classes} {...props}>
      {children ?? text}
    </button>
  );
};

export default Button;
